import { PulseBaseProvider } from '../../base-classes';
import { getTemperature, getPressure, getSpeed } from '../../utilities/unitConversion';
import { unitSystems } from '../../utilities/units';

const _dailyForecastUri = '/data/forecasts/v2/daily';
const _dailyForecastCacheKey = 'dailyForecast';

export class ForecastProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_dailyForecastCacheKey] = this.dailyForecastSyncer.bind(this);
    }

    async dailyForecastSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            location: syncParams.location,
            locationtype: syncParams.locationtype,
            offset: syncParams.offset,
            units: unitSystems.english,
            verbose: syncParams.verbose
        };

        const { tempUnit } = syncParams;
        const dailyUnitConversionFunc = (resultArray) => {
            if (resultArray?.dfp) {
                resultArray.dfp.forEach(result => {
                    result.t = getTemperature(result.t, tempUnit);
                });
            }

            return resultArray;
        };

        const responseValidator = response => {
            return !!response;
        };

        return await super.syncData(syncParams.key, id, queryParams, _dailyForecastUri, resolve, reject, responseValidator, syncParams.pulseApi, null, dailyUnitConversionFunc, true);
    }

    async getDailyForecast(location, locationtype, offset, units, stdParameters, verbose, refresh = false, tempUnit) {
        const syncParams = {
            location,
            locationtype,
            offset: offset && offset >= 0 ? offset : 0,
            verbose: !!verbose,
            refresh,
            tempUnit,
            cultureinfo: stdParameters?.cultureinfo
        };
        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_dailyForecastCacheKey, id);
        }
        return await super.loadFromStorage(_dailyForecastCacheKey, id, syncParams);
    }
}
